import { render, staticRenderFns } from "./threeArea.vue?vue&type=template&id=f90a229a&scoped=true&"
import script from "./threeArea.vue?vue&type=script&lang=js&"
export * from "./threeArea.vue?vue&type=script&lang=js&"
import style0 from "./threeArea.vue?vue&type=style&index=0&id=f90a229a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90a229a",
  null
  
)

export default component.exports